import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import MediaForm from '@Components/MediaForm';
import { MediaContextProvider } from '../../context/mediaContext/mediaContext';
import { getDetailRoutePath, isReadOnlyListType } from '@/utils/mediaTypes';

export default function Edit() {
	const { type, epId } = useParams();
	const navigate = useNavigate();

	useEffect(() => {
		if (type && epId && isReadOnlyListType(type)) {
			navigate(getDetailRoutePath(type, epId), { replace: true });
		}
	}, [type, epId, navigate]);

	return (
		<MediaContextProvider>
			<MediaForm edit />
		</MediaContextProvider>
	);
}
